import React, { createContext, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { ACCESS_TOKEN, setAccessToken } from 'requests/token.request';

interface AuthContextType {
  token?: string;
  handleSetToken: (token: string) => void;
}

interface IProps {
  children: React.ReactNode;
}

const AuthContext = createContext<AuthContextType>({
  token: undefined,
  handleSetToken: () => null,
});

export const useAuth = (): AuthContextType => useContext(AuthContext);

export const AuthProvider: React.FC<IProps> = ({ children }: { children: React.ReactNode }) => {
  const navigate = useNavigate();
  const [token, setToken] = React.useState<string>(localStorage.getItem(ACCESS_TOKEN) as string);

  const handleSetToken = (tokenValue: string) => {
    setToken(tokenValue);
    setAccessToken(tokenValue);
    navigate('/dashboard');
  };

  const value = { token, handleSetToken };
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
